import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import Dialog from '@material-ui/core/Dialog';
import API from '../../../api/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getImageUrl } from '../../../utils/imageUtils';
import { Component } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  IconButton,
  Chip,
  Tooltip
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import PostAddIcon from '@material-ui/icons/PostAdd';
import moment from 'moment';
import AdminPostsDialog from '../../../dialogs/admin-posts/admin-posts';

const garageApi = new API();

class AdminPosts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      adminPostsDialog: false,
      posts: [],
      editPost: {},
    };
  }

  componentDidMount() {
    this.loadPosts();
  }

  loadPosts() {
    garageApi.endpoints.posts.getAll()
      .then((getRequest) => {
        try {
          console.log('Posts API response:', getRequest);
          console.log('Posts data:', getRequest.data);
          
          // Unterstütze sowohl results als auch direkte Arrays
          const posts = Array.isArray(getRequest.data) 
            ? getRequest.data 
            : (getRequest.data?.results || []);
          
          console.log('Parsed posts:', posts);
          console.log('Posts count:', posts.length);
          
          this.setState({ posts: posts, loading: false });
        } catch(e) {
          console.error('Error parsing posts:', e);
          this.setState({ posts: [], loading: false });
        }
      })
      .catch((error) => {
        console.error('Error loading posts:', error);
        console.error('Error response:', error.response);
        this.setState({ posts: [], loading: false });
      });
  }

  deletePost(unikey) {
    if (!window.confirm('Möchten Sie diesen Post wirklich löschen?')) {
      return;
    }

    var deletePost = this.state.posts.find((element) => { return element.unikey === unikey; });
    if (!deletePost) return;

    this.setState({ loading: true });

    garageApi.endpoints.posts.delete({ id: deletePost.id })
      .then(() => {
        this.loadPosts();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  closeAdminPostsDialog() {
    this.setState({ adminPostsDialog: false });
    this.setState({ editPost: {} });
  }

  submitAdminPostsDialog(mode, post, extraImageIds = []) {
    this.setState({ loading: true });

    const syncExtraImages = (postId) => {
      if (!postId) return Promise.resolve();
      return garageApi.endpoints.posts.replaceImages(postId, extraImageIds || [])
        .catch((err) => {
          console.error('Error syncing post images:', err);
          return Promise.resolve();
        });
    };

    if (mode) {
      garageApi.endpoints.posts.create(post)
        .then((response) => {
          const postId = response?.data?.id;
          return syncExtraImages(postId);
        })
        .then(() => this.loadPosts())
        .catch((error) => {
          console.error('Error creating post:', error);
          this.setState({ loading: false });
        });
    } else {
      garageApi.endpoints.posts.update(post)
        .then(() => syncExtraImages(post.id))
        .then(() => this.loadPosts())
        .catch((error) => {
          console.error('Error updating post:', error);
          this.setState({ loading: false });
        });
    }
    this.setState({ adminPostsDialog: false, editPost: {} });
  }

  editPost(unikey) {
    var editPost = this.state.posts.find((element) => { return element.unikey === unikey; });
    this.setState({ editPost: editPost || {} });
    this.setState({ adminPostsDialog: true });
  }

  createPost() {
    this.setState({ adminPostsDialog: true });
  }

  render() {
    const { loading, posts, adminPostsDialog, editPost } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard', '/admin/posts': 'Posts' }}
        menu={{ 'Post Hinzufügen': this.createPost.bind(this) }}
        title="Posts"
        loading={loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <Dialog 
          open={adminPostsDialog} 
          onClose={this.closeAdminPostsDialog.bind(this)}
          maxWidth="md"
          fullWidth
        >
          <AdminPostsDialog 
            postsData={editPost} 
            close={this.closeAdminPostsDialog.bind(this)} 
            submit={this.submitAdminPostsDialog.bind(this)}
          />
        </Dialog>
        
        {!loading && (
          <Box style={{ padding: '20px' }}>
            {/* Statistik */}
            <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h4" style={{ fontWeight: 700, marginBottom: '8px' }}>
                    {posts.length}
                  </Typography>
                  <Typography variant="body1" style={{ opacity: 0.9 }}>
                    {posts.length === 1 ? 'Post' : 'Posts'} insgesamt
                  </Typography>
                </Box>
                <PostAddIcon style={{ fontSize: 60, opacity: 0.3 }} />
              </Box>
            </Paper>

            {/* Posts Grid */}
            {posts.length > 0 ? (
              <Grid container spacing={3}>
                {posts.map((post) => (
                  <Grid item xs={12} sm={6} md={4} key={post.unikey}>
                    <Card 
                      style={{ 
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        position: 'relative',
                        backgroundImage: post.image && getImageUrl(post.image, 'large')
                          ? `url(${getImageUrl(post.image, 'large')})`
                          : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundColor: (post.image && getImageUrl(post.image, 'large')) ? 'transparent' : '#f5f5f5',
                        minHeight: '300px',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                    >
                      {/* Overlay für bessere Lesbarkeit */}
                      {post.image && getImageUrl(post.image, 'large') && (
                        <Box
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)',
                            zIndex: 1,
                          }}
                        />
                      )}
                      <CardContent style={{ 
                        flexGrow: 1, 
                        display: 'flex', 
                        flexDirection: 'column',
                        position: 'relative',
                        zIndex: 2,
                        color: (post.image && getImageUrl(post.image, 'large')) ? 'white' : 'inherit',
                      }}>
                        <Typography variant="h6" component="h2" style={{ fontWeight: 600, marginBottom: '8px' }}>
                          {post.title || 'Ohne Titel'}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          style={{ 
                            marginBottom: '12px',
                            flexGrow: 1,
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            color: (post.image && getImageUrl(post.image, 'large')) ? 'rgba(255,255,255,0.9)' : undefined,
                          }}
                          color={(post.image && getImageUrl(post.image, 'large')) ? undefined : 'textSecondary'}
                        >
                          {post.description || 'Keine Beschreibung'}
                        </Typography>
                        <Box display="flex" alignItems="center" justifyContent="space-between" marginTop="auto">
                          <Box>
                            {post.created && (
                              <Chip 
                                label={moment(post.created).format('DD.MM.YYYY')} 
                                size="small" 
                                style={{ 
                                  fontSize: '0.7rem',
                                  backgroundColor: (post.image && getImageUrl(post.image, 'large')) ? 'rgba(255,255,255,0.2)' : undefined,
                                  color: (post.image && getImageUrl(post.image, 'large')) ? 'white' : undefined,
                                }}
                              />
                            )}
                          </Box>
                          <Box>
                            <Tooltip title="Bearbeiten">
                              <IconButton 
                                size="small" 
                                onClick={() => { this.editPost(post.unikey); }}
                                style={{ color: '#1976d2' }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Löschen">
                              <IconButton 
                                size="small" 
                                onClick={() => { this.deletePost(post.unikey); }}
                                style={{ color: '#d32f2f' }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Paper elevation={2} style={{ padding: '60px', textAlign: 'center' }}>
                <PostAddIcon style={{ fontSize: 80, color: '#ccc', marginBottom: '20px' }} />
                <Typography variant="h6" color="textSecondary" style={{ marginBottom: '8px' }}>
                  Noch keine Posts vorhanden
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Klicken Sie auf "Post Hinzufügen" um Ihren ersten Post zu erstellen.
                </Typography>
              </Paper>
            )}
          </Box>
        )}
      </SecuredZone>
    );
  }
}

export default AdminPosts;
